import { hookstate, useHookstate } from "@hookstate/core";
import { devtools } from "@hookstate/devtools";
import { Connector } from "wagmi";

export enum AccountType {
  MetaMask = "MetaMask",
  Simulator = "Simulator",
  WalletConnect = "WalletConnect",
  NONE = "NONE",
}

export enum Chain {
  SGB = "SGB",
  FLR = "FLR",
  COSTON = "COSTON",
  COSTON2 = "COSTON2",
}

interface IBalance {
  balance: number;
  balanceWrapped: number;
  total: number;
}

interface IStore {
  production: boolean;
  account: string;
  accountType: AccountType;
  accountConnected: boolean;
  chain: Chain;
  connector?: Connector;
  showConnectedToast: boolean;
  balance: IBalance;
}

const initialValue: IStore = {
  production: true,
  account: "",
  accountType: AccountType.NONE,
  accountConnected: false,
  chain: Chain.FLR,
  showConnectedToast: true,
  balance: {
    balance: 0,
    balanceWrapped: 0,
    total: 0,
  },
};

const Store = hookstate<IStore>(initialValue, devtools({ key: "ftso-store" }));

const useStore = () => {
  return useHookstate<IStore>(Store);
};

export { Store, useStore, initialValue };
